import type { IconNode } from '../types';

/**
 * @name igloo
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTggMjAuMmMyLjQtLjcgNC0xLjkgNC0zLjJ2LTVhMTAgMTAgMCAxIDAtMjAgMHY1YzAgMS4zIDEuNiAyLjUgNCAzLjIiIC8+CiAgPHBhdGggZD0iTTYuNSAzLjY1QzcuNSA1IDkuNiA2IDEyIDZzNC41LTEgNS41LTIuMzUiIC8+CiAgPHBhdGggZD0iTTEwLjEgNS44Yy0xIC45LTEuOCAyLjYtMiA0LjYiIC8+CiAgPHBhdGggZD0iTTE1LjkgMTAuNGMtLjMtMi0xLTMuNi0yLTQuNiIgLz4KICA8cGF0aCBkPSJNMy4zIDcuMUM1LjMgOS41IDguNSAxMSAxMiAxMWMzLjUgMCA2LjctMS41IDguNy0zLjkiIC8+CiAgPHBhdGggZD0iTTIgMTJjLjkgMS4yIDIuNCAyLjQgNC4zIDMuMSIgLz4KICA8cGF0aCBkPSJNNiAyMWMwIC42LjQgMSAxIDFoMTBjLjYgMCAxLS40IDEtMXYtNGE2IDYgMCAxIDAtMTIgMFoiIC8+CiAgPHBhdGggZD0iTTE3LjcgMTUuMWMxLjktLjcgMy40LTEuOSA0LjMtMy4xIiAvPgogIDxwYXRoIGQ9Ik0xMCAyMnYtNWEyIDIgMCAxIDEgNCAwdjUiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/igloo
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const igloo: IconNode = [
  [
    'path',
    { d: 'M18 20.2c2.4-.7 4-1.9 4-3.2v-5a10 10 0 1 0-20 0v5c0 1.3 1.6 2.5 4 3.2', key: 't1jw0g' },
  ],
  ['path', { d: 'M6.5 3.65C7.5 5 9.6 6 12 6s4.5-1 5.5-2.35', key: '1ehrgj' }],
  ['path', { d: 'M10.1 5.8c-1 .9-1.8 2.6-2 4.6', key: '19fagp' }],
  ['path', { d: 'M15.9 10.4c-.3-2-1-3.6-2-4.6', key: '1mlnjp' }],
  ['path', { d: 'M3.3 7.1C5.3 9.5 8.5 11 12 11c3.5 0 6.7-1.5 8.7-3.9', key: 'due0oz' }],
  ['path', { d: 'M2 12c.9 1.2 2.4 2.4 4.3 3.1', key: 'to79p6' }],
  ['path', { d: 'M6 21c0 .6.4 1 1 1h10c.6 0 1-.4 1-1v-4a6 6 0 1 0-12 0Z', key: 'jz1y4w' }],
  ['path', { d: 'M17.7 15.1c1.9-.7 3.4-1.9 4.3-3.1', key: '1eevgu' }],
  ['path', { d: 'M10 22v-5a2 2 0 1 1 4 0v5', key: '1raqyd' }],
];

export default igloo;
